import React from "react"

import {FieldGlistGroupProps} from "../../../../../render/glist/glist-group"
import ProjectIconUI5 from "../../../../../../gd-ui/project-icon/project-icon-ui5"

export default function FieldProject_GlistGroupStandard(props:FieldGlistGroupProps) {

    const project               = gd.session.projects.get(props.data.value)!
    const colorClass: string    = 'gd-c-{0}'.f(project.color)
    const classes: string       = Classes("group-cards colored-background", colorClass)

    return (
        <div className={classes}>
            <ProjectIconUI5 className="icon m-r-10" size="13" projectId={props.data.value} colorize={false}/>
            <div className="text">{project.name}</div>
            {!!props.data.isCollapsed && <div className="counter">{props.data.counter}</div>}

            {!props.data.isCollapsed &&
                <div className="group-corners">
                    <div className={Classes("top-corner", colorClass)}/>
                </div>}
        </div>
    )
}
